import {
	FormControl,
	FormControlLabel,
	FormHelperText,
	Switch,
	Theme,
} from "@mui/material"
import { styled } from "@mui/material/styles"
import { ChangeEvent, useCallback, useEffect, useState } from "react"

export type FormErrors = {
	[key: string]: string | undefined
}

const AndroidSwitch = ({
	name,
	errorsList,
	field,
	handleChange,
	handleChangeChildren,
	isCheckedProps,
	label,
}: {
	name: string
	errorsList?: FormErrors | undefined
	field: string
	handleChange?: (field: string) => Function
	handleChangeChildren?: (event: ChangeEvent<HTMLInputElement>) => Function
	isCheckedProps: boolean
	label: string
}) => {
	const [isChecked, setIsChecked] = useState(false)

	useEffect(() => {
		if (isCheckedProps !== isChecked) setIsChecked(isCheckedProps)
	}, [isCheckedProps])

	const AndroidOnOffSwitch = styled(Switch)(({ theme }: { theme: Theme }) => ({
		padding: 8,
		"& .MuiSwitch-track": {
			borderRadius: 22 / 2,
			"&::before, &::after": {
				content: '""',
				position: "absolute",
				top: "50%",
				transform: "translateY(-50%)",
				width: 16,
				height: 16,
			},
			"&::before": {
				backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
					theme.palette.primary.contrastText
				)}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
				left: 12,
			},
			"&::after": {
				backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
					theme.palette.primary.contrastText
				)}" d="M19,13H5V11H19V13Z" /></svg>')`,
				right: 12,
			},
		},
		"& .MuiSwitch-thumb": {
			boxShadow: "none",
			width: 16,
			height: 16,
			margin: 2,
		},
	}))

	const handleChangeSwitch = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			setIsChecked(event.target.checked)

			if (handleChange) {
				handleChange(field)(event.target.checked)
			} else if (handleChangeChildren) {
				handleChangeChildren(event)
			}
		},
		[handleChange, handleChangeChildren, field]
	)

	return (
		<FormControl
			error={Boolean(errorsList && errorsList[field])} // Mostra errore solo se presente
		>
			<FormControlLabel
				control={
					<AndroidOnOffSwitch
						name={name}
						checked={isChecked}
						onChange={(switchCase: ChangeEvent<HTMLInputElement>) =>
							handleChangeSwitch(switchCase)
						}
					/>
				}
				label={label}
			/>
			<FormHelperText id={`${field}_switch-helper-text`}>
				{errorsList && errorsList[field] ? `Error: ${errorsList[field]}` : ""}
			</FormHelperText>
		</FormControl>
	)
}

export default AndroidSwitch
